module.exports = __webpack_public_path__ + "img/b61ca3c55195bf6f46ab6e74eb3cb2a4.png";